import { create, HEADERS } from 'apisauce'
import Config from '../../config'
import {
  ApiResponse,
  
  AddressFindResponse,

  SessionRequestResponse,
  SessionRegisterResponse,
  SessionInfoResponse,

  QuestionListResponse,
  QuestionGetAnswersResponse,
  QuestionSaveResponse,
  QuestionTranslationSaveResponse,
  QuestionTranslationDeleteResponse,

  QuestionGroupListResponse,

  IQuestionTemplateListResponse,
  IQuestionTemplateSaveResponse,

  SpecieListResponse,
  SpecieSaveResponse,
  SpecieDeleteResponse,

  ShelterListResponse,
  ShelterSaveResponse,
  ShelterCreateResponse,
  ShelterVerifySlugResponse,
  ShelterToggleActiveResponse,

  TokenListResponse,
  TokenGenerateResponse,

  MappingAgeListResponse,
  MappingAgeSaveResponse,

  MappingAgeRangeListResponse,
  MappingAgeRangeSaveResponse,

  MappingBreedListResponse,
  MappingBreedSaveResponse,

  MappingSexListResponse,
  MappingSexSaveResponse,

  MappingSizeListResponse,
  MappingSizeSaveResponse,

  MappingSpecieListResponse,
  MappingSpecieSaveResponse,

  MappingStatsPendingCountResponse,

  PartnerListResponse,

  AgeListResponse,

  SizeListResponse,

  SexListResponse,

  BreedListResponse,
  BreedSaveResponse,
  BreedDeleteResponse,

  GroupListResponse,
  GroupSaveResponse,
  GroupDeleteResponse,

  ShelterSettingListResponse,
  ShelterSettingIframeSaveResponse,
  ShelterSettingKennelCardSaveResponse,
  ShelterSettingAdoptionSaveResponse,
  ShelterSettingSponsorSaveResponse,
  ShelterSettingKiokSaveResponse,
  ShelterSettingInPersonSaveResponse,

  ShelterQuestionUpdateResponse,
  ShelterPaymentConfigSaveResponse,

  ShelterKioskLogoUpdateResponse,

  PetListResponse,
  PetRestoreResponse,

  AdoptionApplicationListResponse,
  AdoptionApplicationCheckoutUpdateResponse,
  AdoptionApplicationReturnResponse,
  AdoptionApplicationCheckoutRemoveProductResponse,
  AdoptionApplicationForceSetAdoptedResponse,

  AdminRoleListResponse,
  AdminRoleFindResponse,
  AdminRoleCreateResponse,
  AdminRoleUpdateResponse,
  AdminRoleDeleteResponse,

  AdminUserListResponse,
  AdminUserCreateResponse,
  AdminUserUpdateResponse,
  AdminUserDeleteResponse,
  AdminUserResetPasswordResponse,

  ShelterProductListResponse,
  ShelterProductSaveResponse,
  ShelterProductDeleteResponse,

  ShelterTaxListResponse,
  ShelterTaxSaveResponse,
  ShelterTaxDeleteResponse,

  PaymentModelListResponse,

  SponsorListResponse,
  SponsorSaveResponse,
  SponsorDeleteResponse,

  EventListResponse,
  EventSaveResponse,
  EventDeleteResponse,

  EmailTemplateList,
  EmailTemplateUpdate,
  EmailTemplatePreview,
  EmailTemplateTranslationSave,
  EmailTemplateTranslationDelete,

  LanguageList,

  IntegrationList,
  CountryList,

  KioskListResponse,
  KioskCreateResponse,

  KioskReasonListResponse,
  ShelterKioskReasonListResponse,
  ShelterKioskReasonCreateResponse,
  ShelterKioskReasonUpdateResponse,
  ShelterKioskReasonDeleteResponse,
  ShelterKioskReasonUpdateQuestionResponse,
  ShelterKioskReasonTranslationSaveResponse,
  ShelterKioskReasonTranslationDeleteResponse,

  ShelterActivateInPersonResponse,

  QrCodeTypeListResponse,
  QrCodeListResponse,
  QrCodeCreateResponse,
  QrCodeUpdateResponse,
  QrCodeDeleteResponse,

  ShelterSettingAdopterPersonalDocumentsSaveResponse,

  ApplicationTagListResponse,
  ApplicationTagShelterListResponse,
  ApplicationTagShelterSaveResponse,
  ApplicationTagEventListResponse,
  ApplicationTagEventSaveResponse,
  ApplicationTagEnableResponse,
  ShelterKioskReasonSmartResponseResponse,
  ShelterSettingAdoptionPathSaveResponse,

  CharacteristicsListResponse,
  CharacteristicsSaveResponse,
  ShelterSettingPetProfileSaveResponse,
  ShelterSettingSponsorShipSaveResponse,
  MappingCharacteristicSaveResponse,
  MappingCharacteristicListResponse,
} from './interfaces/ApiResponse'
import { ShelterSettingSponsorShipDeleteRequest, ShelterSettingSponsorShipSaveRequest } from './interfaces/ApiRequest'

// Create our ApiSauce instance
const api = create({
  baseURL: Config.baseAPI
})
const apiAddress = create({
  baseURL: Config.addressAPI
})
/*const apiService = create({
  baseURL: Config.serviceAPI
})*/

// Configuration
export const setHeaders = (opts: HEADERS) => api.setHeaders(opts)
export const setURL = (url: string) => api.setBaseURL(url)
export const setToken = (token: string) => api.setHeader('Authorization', `Bearer ${token}`)

// Address API
export const findAddress = async (data: any) => await apiAddress.post('geocode', data) as ApiResponse<AddressFindResponse>

// Auth Methods
export const sessionRequest = async (data: any) => await api.post('auth/session-request', data) as ApiResponse<SessionRequestResponse>
export const sessionRegister = async (data: any) => await api.post('auth/session-register', data) as ApiResponse<SessionRegisterResponse>
export const sessionInfo = async (data: any) => await api.post('auth/session-info', data) as ApiResponse<SessionInfoResponse>


// Invoice Methods
export const invoiceList = async (data: any) => await api.post('payment-cycle/search', data) as ApiResponse<any>
export const invoiceSetPaid = async (data: any) => await api.post('payment-cycle/set-paid', data) as ApiResponse<any>

// Credits Methods
export const creditsList = async (data: any) => await api.post('payment-credit/search', data) as ApiResponse<any>
export const creditsCreate = async (data: any) => await api.post('payment-credit/create-voucher', data) as ApiResponse<any>

// Questions Methods
export const questionList = async (data: any) => await api.post('question/search', data) as ApiResponse<QuestionListResponse>
export const questionGetAnswers = async (data: any) => await api.post('question/get-answers', data) as ApiResponse<QuestionGetAnswersResponse>
export const questionSave = async (data: any) => await api.post('question/save', data) as ApiResponse<QuestionSaveResponse>
export const questionTranslationSave = async (data: any) => await api.post('question/save-translation', data) as ApiResponse<QuestionTranslationSaveResponse>
export const questionTranslationDelete = async (data: any) => await api.post('question/delete-translation', data) as ApiResponse<QuestionTranslationDeleteResponse>

// Questions Groups Methods
export const questionGroupList = async (data: any) => await api.post('question-group/search', data) as ApiResponse<QuestionGroupListResponse>

// Questions Groups Methods
export const questionTemplateList = async (data: any) => await api.post('question-template/search', data) as ApiResponse<IQuestionTemplateListResponse>
export const questionTemplateSave = async (data: any) => await api.post('question-template/save', data) as ApiResponse<IQuestionTemplateSaveResponse>

// Species Methods
export const specieList = async (data: any) => await api.post('specie/search', data) as ApiResponse<SpecieListResponse>
export const specieCreate = async (data: any) => await api.post('specie/create', data) as ApiResponse<SpecieSaveResponse>
export const specieUpdate = async (data: any) => await api.post('specie/update', data) as ApiResponse<SpecieSaveResponse>
export const specieDelete = async (data: any) => await api.post('specie/delete', data) as ApiResponse<SpecieDeleteResponse>

// Announcement Methods
export const announcementList = async (data: any) => await api.post('announcement/search', data) as ApiResponse<any>
export const announcementCreate = async (data: any) => await api.post('announcement/create', data) as ApiResponse<any>
export const announcementUpdate = async (data: any) => await api.post('announcement/update', data) as ApiResponse<any>
export const announcementDelete = async (data: any) => await api.post('announcement/turn-off', data) as ApiResponse<any>

// Shelter Methods
export const shelterList = async (data: any) => await api.post('shelter/search', data) as ApiResponse<ShelterListResponse>
export const shelterSave = async (data: any) => await api.post('shelter/save', data) as ApiResponse<ShelterSaveResponse>
export const shelterCreate = async (data: any) => await api.post('shelter/create', data) as ApiResponse<ShelterCreateResponse>
export const shelterVerifySlug = async (data: any) => await api.post('shelter/verify-slug', data) as ApiResponse<ShelterVerifySlugResponse>
export const shelterToggleActive = async (data: any) => await api.post('shelter/toggle-active', data) as ApiResponse<ShelterToggleActiveResponse>
export const shelterQuestionUpdate = async (data: any) => await api.post('shelter/update-question', data) as ApiResponse<ShelterQuestionUpdateResponse>
export const shelterPaymentConfigSave = async (data: any) => await api.post('shelter/save-payment-config', data) as ApiResponse<ShelterPaymentConfigSaveResponse>
export const shelterKioskLogoUpdate = async (data: any) => await api.post('shelter/update-kiosk-logo', data) as ApiResponse<ShelterKioskLogoUpdateResponse>
export const shelterApiKeySave = async (data: any) => await api.post('shelter/api', data) as ApiResponse<any>


// Token Methods
export const tokenList = async (data: any) => await api.post('token/search', data) as ApiResponse<TokenListResponse>
export const tokenGenerate = async (data: any) => await api.post('token/generate', data) as ApiResponse<TokenGenerateResponse>

// Mapping Age Methods
export const mappingAgeList = async (data: any) => await api.post('mapping-age/search', data) as ApiResponse<MappingAgeListResponse>
export const mappingAgeSave = async (data: any) => await api.post('mapping-age/save', data) as ApiResponse<MappingAgeSaveResponse>

// Mapping Age Range Methods
export const mappingAgeRangeList = async (data: any) => await api.post('mapping-age-range/search', data) as ApiResponse<MappingAgeRangeListResponse>
export const mappingAgeRangeSave = async (data: any) => await api.post('mapping-age-range/save', data) as ApiResponse<MappingAgeRangeSaveResponse>

// Mapping Breed Methods
export const mappingBreedList = async (data: any) => await api.post('mapping-breed/search', data) as ApiResponse<MappingBreedListResponse>
export const mappingBreedSave = async (data: any) => await api.post('mapping-breed/save', data) as ApiResponse<MappingBreedSaveResponse>

// Mapping Sex Methods
export const mappingSexList = async (data: any) => await api.post('mapping-sex/search', data) as ApiResponse<MappingSexListResponse>
export const mappingSexSave = async (data: any) => await api.post('mapping-sex/save', data) as ApiResponse<MappingSexSaveResponse>

// Mapping Size Methods
export const mappingSizeList = async (data: any) => await api.post('mapping-size/search', data) as ApiResponse<MappingSizeListResponse>
export const mappingSizeSave = async (data: any) => await api.post('mapping-size/save', data) as ApiResponse<MappingSizeSaveResponse>

// Mapping Specie Methods
export const mappingSpecieList = async (data: any) => await api.post('mapping-specie/search', data) as ApiResponse<MappingSpecieListResponse>
export const mappingSpecieSave = async (data: any) => await api.post('mapping-specie/save', data) as ApiResponse<MappingSpecieSaveResponse>

// Mapping Characteristic Methods
export const mappingCharacteristicList = async (data: any) => await api.post('mapping-characteristic/search', data) as ApiResponse<MappingCharacteristicListResponse>
export const mappingCharacteristicSave = async (data: any) => await api.post('mapping-characteristic/save', data) as ApiResponse<MappingCharacteristicSaveResponse>

// Mapping Stats Methods
export const mappingStatsPendingCount = async () => await api.post('mapping-stats/pending-count') as ApiResponse<MappingStatsPendingCountResponse>

// Partner Methods
export const partnerList = async (data: any) => await api.post('partner/search', data) as ApiResponse<PartnerListResponse>

// Age Methods
export const ageList = async (data: any) => await api.post('age/search', data) as ApiResponse<AgeListResponse>

// Size Methods
export const sizeList = async (data: any) => await api.post('size/search', data) as ApiResponse<SizeListResponse>

// Sex Methods
export const sexList = async (data: any) => await api.post('gender/search', data) as ApiResponse<SexListResponse>

// Breed Methods
export const breedList = async (data: any) => await api.post('breed/search', data) as ApiResponse<BreedListResponse>
export const breedCreate = async (data: any) => await api.post('breed/create', data) as ApiResponse<BreedSaveResponse>
export const breedUpdate = async (data: any) => await api.post('breed/update', data) as ApiResponse<BreedSaveResponse>
export const breedDelete = async (data: any) => await api.post('breed/delete', data) as ApiResponse<BreedDeleteResponse>

// Group Methods
export const groupList = async (data: any) => await api.post('group/search', data) as ApiResponse<GroupListResponse>
export const groupCreate = async (data: any) => await api.post('group/create', data) as ApiResponse<GroupSaveResponse>
export const groupUpdate = async (data: any) => await api.post('group/update', data) as ApiResponse<GroupSaveResponse>
export const groupDelete = async (data: any) => await api.post('group/delete', data) as ApiResponse<GroupDeleteResponse>

// Shelter Setting Methods
export const shelterSettingList = async (data: any) => await api.post('shelter-settings/search', data) as ApiResponse<ShelterSettingListResponse>
export const shelterSettingIframeSave = async (data: any) => await api.post('shelter-settings/save-iframe', data) as ApiResponse<ShelterSettingIframeSaveResponse>
export const shelterSettingKennelCardSave = async (data: any) => await api.post('shelter-settings/save-kennel-card', data) as ApiResponse<ShelterSettingKennelCardSaveResponse>
export const shelterSettingAdoptionSave = async (data: any) => await api.post('shelter-settings/save-adoption', data) as ApiResponse<ShelterSettingAdoptionSaveResponse>
export const shelterSettingPetProfileSave = async (data: any) => await api.post('shelter-settings/save-pet-profile', data) as ApiResponse<ShelterSettingPetProfileSaveResponse>
export const shelterSettingDiscountReasonSave = async (data: any) => await api.post('shelter-settings/save-discount-reason', data) as ApiResponse<ShelterSettingPetProfileSaveResponse>
export const shelterSettingSponsorSave = async (data: any) => await api.post('shelter-settings/save-sponsor', data) as ApiResponse<ShelterSettingSponsorSaveResponse>
export const shelterSettingAdoptionPathSave = async (data: any) => await api.post('shelter-settings/save-adoption-path-message', data) as ApiResponse<ShelterSettingAdoptionPathSaveResponse>
export const shelterSettingKioskSave = async (data: any) => await api.post('shelter-settings/save-kiosk', data) as ApiResponse<ShelterSettingKiokSaveResponse>
export const shelterSettingInPersonSave = async (data: any) => await api.post('shelter-settings/save-in-person', data) as ApiResponse<ShelterSettingInPersonSaveResponse>
export const shelterSettingAdopterPersonalDocumentsSave = async (data: any) => await api.post('shelter-settings/save-adopter-personal-documents', data) as ApiResponse<ShelterSettingAdopterPersonalDocumentsSaveResponse>

// Sponsor Ship Methods
export const shelterSettingSponsorShipSave = async (data: ShelterSettingSponsorShipSaveRequest) => await api.post('sponsorship-type/create', data) as ApiResponse<ShelterSettingSponsorShipSaveResponse>
export const shelterSettingSponsorShipUpdate = async (data: ShelterSettingSponsorShipSaveRequest) => await api.post('sponsorship-type/update', data) as ApiResponse<ShelterSettingSponsorShipSaveResponse>
export const shelterSettingSponsorShipDelete = async (data: ShelterSettingSponsorShipDeleteRequest) => await api.post('sponsorship-type/delete', data) as ApiResponse<ShelterSettingSponsorShipSaveResponse>
export const shelterSettingSponsorShipList = async (data: any) => await api.post('sponsorship-type/search', data) as ApiResponse<ShelterSettingSponsorShipSaveResponse>

// Pet methods
export const petList = async (data: any) => await api.post('pet/search', data) as ApiResponse<PetListResponse>
export const petRestore = async (data: any) => await api.post('pet/restore-pet', data) as ApiResponse<PetRestoreResponse>

// Adoption Application methods
export const adoptionApplicationList = async (data: any) => await api.post('application/search', data) as ApiResponse<AdoptionApplicationListResponse>
export const adoptionApplicationReturn = async (data: any) => await api.post('application/adoption-return', data) as ApiResponse<AdoptionApplicationReturnResponse>
export const adoptionApplicationCheckoutRemoveProduct = async (data: any) => await api.post('application/remove-checkout-product', data) as ApiResponse<AdoptionApplicationCheckoutRemoveProductResponse>
export const adoptionApplicationCheckoutUpdate = async (data: any) => await api.post('application/checkout-update', data) as ApiResponse<AdoptionApplicationCheckoutUpdateResponse>
export const adoptionApplicationForceSetAdopted = async (data: any) => await api.post('application/force-set-adopted', data) as ApiResponse<AdoptionApplicationForceSetAdoptedResponse>
export const adoptionApplicationForceSetAvailable = async (data: any) => await api.post('application/force-set-available', data) as ApiResponse<AdoptionApplicationForceSetAdoptedResponse>

// Admin Roles methods
export const adminRoleList = async (data: any) => await api.post('role/list', data) as ApiResponse<AdminRoleListResponse>
export const adminRoleFind = async (data: any) => await api.post('role/find', data) as ApiResponse<AdminRoleFindResponse>
export const adminRoleCreate = async (data: any) => await api.post('role/create', data) as ApiResponse<AdminRoleCreateResponse>
export const adminRoleUpdate = async (data: any) => await api.post('role/update', data) as ApiResponse<AdminRoleUpdateResponse>
export const adminRoleDelete = async (data: any) => await api.post('role/delete', data) as ApiResponse<AdminRoleDeleteResponse>

// Admin User methods
export const adminUserList = async (data: any) => await api.post('user/search', data) as ApiResponse<AdminUserListResponse>
export const adminUserCreate = async (data: any) => await api.post('user/create', data) as ApiResponse<AdminUserCreateResponse>
export const adminUserUpdate = async (data: any) => await api.post('user/update', data) as ApiResponse<AdminUserUpdateResponse>
export const adminUserDelete = async (data: any) => await api.post('user/delete?force=true', data) as ApiResponse<AdminUserDeleteResponse>
export const adminUserResetPassword = async (data: any) => await api.post('user/reset-password', data) as ApiResponse<AdminUserResetPasswordResponse>
export const adopterUserDelete = async (data: any,force: string) => await api.post('adopter-user/delete-account?force='+force, data) as ApiResponse<any>

// Shelter Product methods
export const shelterProductList = async (data: any) => await api.post('product/search', data) as ApiResponse<ShelterProductListResponse>
export const shelterProductCreate = async (data: any) => await api.post('product/create', data) as ApiResponse<ShelterProductSaveResponse>
export const shelterProductUpdate = async (data: any) => await api.post('product/update', data) as ApiResponse<ShelterProductSaveResponse>
export const shelterProductDelete = async (data: any) => await api.post('product/delete?force=true', data) as ApiResponse<ShelterProductDeleteResponse>

// Shelter Tax methods
export const shelterTaxList = async (data: any) => await api.post('tax/search', data) as ApiResponse<ShelterTaxListResponse>
export const shelterTaxCreate = async (data: any) => await api.post('tax/create', data) as ApiResponse<ShelterTaxSaveResponse>
export const shelterTaxUpdate = async (data: any) => await api.post('tax/update', data) as ApiResponse<ShelterTaxSaveResponse>
export const shelterTaxDelete = async (data: any) => await api.post('tax/delete?force=true', data) as ApiResponse<ShelterTaxDeleteResponse>

// Payment Model
export const paymentModelList = async (data: any) => await api.post('payment-model/search', data) as ApiResponse<PaymentModelListResponse>

// Sponsors
export const sponsorList = async (data: any) => await api.post('sponsor/search', data) as ApiResponse<SponsorListResponse>
export const sponsorCreate = async (data: any) => await api.post('sponsor/create', data) as ApiResponse<SponsorSaveResponse>
export const sponsorUpdate = async (data: any) => await api.post('sponsor/update', data) as ApiResponse<SponsorSaveResponse>
export const sponsorDelete = async (data: any) => await api.post('sponsor/delete', data) as ApiResponse<SponsorDeleteResponse>

// Events
export const eventList = async (data: any) => await api.post('event/search', data) as ApiResponse<EventListResponse>
export const eventCreate = async (data: any) => await api.post('event/create', data) as ApiResponse<EventSaveResponse>
export const eventUpdate = async (data: any) => await api.post('event/update', data) as ApiResponse<EventSaveResponse>
export const eventDelete = async (data: any) => await api.post('event/delete', data) as ApiResponse<EventDeleteResponse>

// Email template
export const emailTemplateList = async (data: any) => await api.post('email-template/search', data) as ApiResponse<EmailTemplateList>
export const emailTemplateUpdate = async (data: any) => await api.post('email-template/update', data) as ApiResponse<EmailTemplateUpdate>
export const emailTemplatePreview = async (data: any) => await api.post('email-template/preview', data) as ApiResponse<EmailTemplatePreview>
export const emailTemplateTranslationSave = async (data: any) => await api.post('email-template/translation-save', data) as ApiResponse<EmailTemplateTranslationSave>
export const emailTemplateTranslationDelete = async (data: any) => await api.post('email-template/translation-delete', data) as ApiResponse<EmailTemplateTranslationDelete>

// Language
export const languageList = async (data: any) => await api.post('language/search', data) as ApiResponse<LanguageList>

// Country
export const countryList = async (data: any) => await api.post('country/search', data) as ApiResponse<CountryList>

// Integration
export const integrationList = async (data: any) => await api.post('integration/search', data) as ApiResponse<IntegrationList>



// Kiosk
export const kioskList = async (data: any) => await api.post('kiosk/search', data) as ApiResponse<KioskListResponse>
export const kioskCreate = async (data: any) => await api.post('kiosk/create', data) as ApiResponse<KioskCreateResponse>
export const kioskReasonList = async (data: any) => await api.post('kiosk-reason/search', data) as ApiResponse<KioskReasonListResponse>
export const shelterKioskReasonList = async (data: any) => await api.post('shelter-kiosk-reason/search', data) as ApiResponse<ShelterKioskReasonListResponse>
export const shelterKioskReasonCreate = async (data: any) => await api.post('shelter-kiosk-reason/create', data) as ApiResponse<ShelterKioskReasonCreateResponse>
export const shelterKioskReasonUpdate = async (data: any) => await api.post('shelter-kiosk-reason/update', data) as ApiResponse<ShelterKioskReasonUpdateResponse>
export const shelterKioskReasonDelete = async (data: any) => await api.post('shelter-kiosk-reason/delete', data) as ApiResponse<ShelterKioskReasonDeleteResponse>
export const shelterKioskReasonUpdateQuestion = async (data: any) => await api.post('shelter-kiosk-reason/update-question', data) as ApiResponse<ShelterKioskReasonUpdateQuestionResponse>
export const shelterKioskReasonTranslationSave = async (data: any) => await api.post('shelter-kiosk-reason/translation-save', data) as ApiResponse<ShelterKioskReasonTranslationSaveResponse>
export const shelterKioskReasonTranslationDelete = async (data: any) => await api.post('shelter-kiosk-reason/translation-delete', data) as ApiResponse<ShelterKioskReasonTranslationDeleteResponse>
export const shelterKioskReasonSmartResponseGet = async (data: any) => await api.post('shelter-kiosk-reason/smart-response-sms', data) as ApiResponse<ShelterKioskReasonSmartResponseResponse>
export const shelterKioskReasonSmartResponseSave = async (data: any) => await api.post('shelter-kiosk-reason/smart-response-sms-save', data) as ApiResponse<ShelterKioskReasonSmartResponseResponse>

// In Person
export const shelterActivateInPerson = async (data: any) => await api.post('shelter/activate-in-person', data) as ApiResponse<ShelterActivateInPersonResponse>

// QrCode
export const qrCodeTypeList = async (data: any) => await api.post('qr-code-type/search', data) as ApiResponse<QrCodeTypeListResponse>
export const qrCodeList = async (data: any) => await api.post('qr-code/search', data) as ApiResponse<QrCodeListResponse>
export const qrCodeCreate = async (data: any) => await api.post('qr-code/create', data) as ApiResponse<QrCodeCreateResponse>
export const qrCodeUpdate = async (data: any) => await api.post('qr-code/update', data) as ApiResponse<QrCodeUpdateResponse>
export const qrCodeDelete = async (data: any) => await api.post('qr-code/delete', data) as ApiResponse<QrCodeDeleteResponse>

// Application Tag
export const applicationTagList = async (data: any) => await api.post('application-tag/search', data) as ApiResponse<ApplicationTagListResponse>
export const applicationTagEnable = async (data: any) => await api.post('application-tag/enable', data) as ApiResponse<ApplicationTagEnableResponse>
export const applicationTagShelterList = async (data: any) => await api.post('application-tag/shelter-tag-list', data) as ApiResponse<ApplicationTagShelterListResponse>
export const applicationTagShelterSave = async (data: any) => await api.post('application-tag/shelter-tag-save', data) as ApiResponse<ApplicationTagShelterSaveResponse>
export const applicationTagEventList = async (data: any) => await api.post('application-tag/shelter-event-list', data) as ApiResponse<ApplicationTagEventListResponse>
export const applicationTagEventSave = async (data: any) => await api.post('application-tag/shelter-event-save', data) as ApiResponse<ApplicationTagEventSaveResponse>

// Characteristics
export const characteristicsList = async (data) => {
  const response = await api.post('characteristic/search', data) as ApiResponse<CharacteristicsListResponse>
  const result = response.data.data

  return result
}
export const characteristicsSave = async (data: any) => await api.post('shelter-settings/save-pet-characteristics-alias', data) as ApiResponse<CharacteristicsSaveResponse>
